module.exports = __webpack_public_path__ + "static/media/risk.060aa73c.png";